import React from "react";

export default function SQLServer_MIN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_MIN</h1>
      <p>This is the SQLServer_MIN component generated from the SQL JSON.</p>
    </div>
  );
}
